import styled from 'styled-components';

const Wrapper = styled.div`
  display:flex;
  flex-direction:column;
  justify-content:flex-start;
  align-items:center;
`;
const Header = styled.div`
  width:100%;
  height:auto;
  display:flex;
  flex-direction:row;
  justify-content:space-between;
  align-items:center;
  margin: 10px 0 30px;
  @media (max-width: 1000px) {
    flex-direction:column;
    align-items:flex-start;
  }

`;
const ControlWrapper = styled.div`
  width:100%;
  display:flex;
  justify-content:flex-end;
  align-items:center;
  gap:15px; 
  @media (max-width:1000px) {
    justify-content:flex-start;
  }
`;
const H2 = styled.h2`
  font-size:4.5em;
  align-self:flex-start;
  color: var(--primary-color)!important;
  padding:4px 0;
  margin: 5px 0;
`;


const SearchInput = styled.input`
  height: 2.5em;
  width: 300px;
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 15px;
  color: var(--font-on-background-color);
  background:#FFF;
  background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="%235b616a" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-search"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>');
  background-repeat: no-repeat;
  background-size: 16px;
  background-position: calc(100% - 10px) center; 
  transition: all 0.3s;
  &::placeholder {

    color: #5b616a; 
    opacity: 1; 
  }
`;
const IconButton = styled.button`
  padding: 8px 12px;
  background-color:  var(--secondary-color);
  color:var(--font-on-secondary-color);
  border: none;
  border-radius: 5px;
  cursor: pointer;
  text-decoration: none;
  font-size: 16px;
  &:hover {
    background-color:var(--secondary-hover-color);
  }
`;

export { Wrapper, ControlWrapper, Header, H2, SearchInput, IconButton };